/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Warm_Falcon_GlideInputs */

const en_quick_warm_falcon_glide = /** @type {(inputs: Quick_Warm_Falcon_GlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom intro background`)
};

const de_quick_warm_falcon_glide = /** @type {(inputs: Quick_Warm_Falcon_GlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierter Intro-Hintergrund`)
};

/**
* | output |
* | --- |
* | "Custom intro background" |
*
* @param {Quick_Warm_Falcon_GlideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quick_warm_falcon_glide = /** @type {((inputs?: Quick_Warm_Falcon_GlideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Warm_Falcon_GlideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quick_warm_falcon_glide(inputs)
	return de_quick_warm_falcon_glide(inputs)
});